module.exports = __webpack_public_path__ + "img/Group-112.c95b08f0.webp";